/**
 * Route: /tags — F031
 *
 * Tags-Übersichtseite.
 */
import { createFileRoute } from '@tanstack/react-router'
import { TagsListPage } from '../features/tags/TagsListPage'

export const Route = createFileRoute('/_auth/tags')({
  component: TagsListPage,
})